import { getIdOrNull, requestWithPromise } from '..'
import { HttpMethods, makeQueryString } from '../apiHelper'
import apiClient from './apiClient'

export const getExternalContacts = (user, parameters) => {
  return requestWithPromise(
    `/api/external-contacts${makeQueryString(parameters)}`,
    HttpMethods.GET,
    null,
    user
  )
}

export const addExternalContact = (user, externalContact) =>
  apiClient.post(user, 'api/external-contacts', externalContact.toRequestBody())

export const updateExternalContact = (user, externalContact) =>
  apiClient.patch(user, `api/external-contacts/${getIdOrNull(externalContact)}`, externalContact.toRequestBody())

export const deleteExternalContact = (user, externalContact) =>
  apiClient.delete(user, `api/external-contacts/${getIdOrNull(externalContact)}`)
